import Vue from 'vue';
import Vuetify, {
  VSnackbar, VBtn, VIcon, VRow, VCol, VSpacer, VBreadcrumbs, VTextField,
  VCard, VCardText, VCardActions, VCardTitle, VCardSubtitle,
  VSelect, VDatePicker, VMenu, VProgressCircular, VDialog,
  VList, VListItem, VListItemAction, VListItemContent, VListItemGroup,
  VListItemSubtitle, VListItemTitle, VToolbarTitle, VToolbar,
  VChip, VChipGroup, VTooltip, VAutocomplete, VContainer, VContent, VBadge,
  VTimePicker, VTextarea, VTimeline, VTimelineItem, VRating, VDivider,
  VListItemIcon, VTabItem, VTabsItems, VTabs, VTab, VSubheader, VAvatar,
  VExpansionPanel, VExpansionPanelHeader, VExpansionPanels, VExpansionPanelContent,
  VDataTable,
} from 'vuetify/lib';

Vue.use(Vuetify, {
  components: {
    VSnackbar,
    VBtn,
    VIcon,
    VRow,
    VCol,
    VSpacer,
    VBreadcrumbs,
    VTextField,
    VCard,
    VCardText,
    VCardActions,
    VCardTitle,
    VCardSubtitle,
    VSelect,
    VDatePicker,
    VMenu,
    VProgressCircular,
    VDialog,
    VList,
    VListItem,
    VListItemAction,
    VListItemContent,
    VListItemGroup,
    VListItemSubtitle,
    VListItemTitle,
    VToolbarTitle,
    VToolbar,
    VChip,
    VChipGroup,
    VTooltip,
    VAutocomplete,
    VContainer,
    VContent,
    VBadge,
    VTimePicker,
    VTextarea,
    VTimeline,
    VTimelineItem,
    VRating,
    VDivider,
    VListItemIcon,
    VTabItem,
    VTabsItems,
    VTabs,
    VTab,
    VSubheader,
    VAvatar,
    VExpansionPanel,
    VExpansionPanelHeader,
    VExpansionPanels,
    VExpansionPanelContent,
    VDataTable,
  },
});

const PRIMARY_COLOR = '#305CA5';
const SECONDARY_COLOR = '#EF4F1F';

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: PRIMARY_COLOR,
        secondary: SECONDARY_COLOR,
        accent: SECONDARY_COLOR,
      },
    },
  },
});
